;(function () {
  'use strict'

  angular.module('contrast.filters').filter('snakeCase', function () {
    return function (input) {
      return typeof input === 'string'
        ? input.replace(/_/, '-').toLowerCase()
        : input
    }
  })
})()
